import React from "react"
import PropTypes from "prop-types"

import TopicTags from './TopicTags'
import SearchBar from './SearchBar'
import TopicSelector from './TopicSelector'
import TopicElement from './TopicElement'

class TopicsContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      selectedTab: '',
      selectedTags: [],
      allTopics: '',
      myTopics: '',
      savedTopics: '',
      savedTopicsIds: [],
      tags: [],
      searchText: ''
    }

    this.onSelectTab = this.onSelectTab.bind(this)
    this.updateSelectedTags = this.updateSelectedTags.bind(this)
    this.getAllTopics = this.getAllTopics.bind(this)
    this.showTopics = this.showTopics.bind(this)
    this.getTopicsApiCall = this.getTopicsApiCall.bind(this)
    this.unfavoriteTopic = this.unfavoriteTopic.bind(this)
    this.favoriteTopic = this.favoriteTopic.bind(this)
    this.searchTopics = this.searchTopics.bind(this)
    this.updateSearchText = this.updateSearchText.bind(this)
    this.topicList = this.topicList.bind(this)
  }

  getAllTopics() {
    $.ajax({
      url: `../get_all_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          allTopics: JSON.parse(data.data.exchanges),
          savedTopicsIds: JSON.parse(data.data.favorite_exchanges),
          tags: JSON.parse(data.data.tags)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateSearchText(text) {
    this.setState({
      searchText: text
    }, () => this.searchTopics())
  }

  searchTopics() {
    $.ajax({
      url: `../search_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      data: {
        searchText: this.state.searchText,
        tags: this.state.selectedTags
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          allTopics: JSON.parse(data.data.exchanges),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getMyTopics() {
    $.ajax({
      url: `../get_my_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          myTopics: JSON.parse(data.data.exchanges),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getFavTopics() {
    $.ajax({
      url: `../get_favorite_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          savedTopics: JSON.parse(data.data.exchanges),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getTopicsApiCall() {
    if(this.state.selectedTab === 3) {
      this.getAllTopics()
    } else if (this.state.selectedTab === 2) {
      this.getMyTopics()
    } else if (this.state.selectedTab === 1) {
      this.getFavTopics()
    }
  }


  componentWillMount() {
    if(this.state.selectedTab === '') {
      this.setState({
        selectedTab: 3
      }, () => this.getTopicsApiCall())
    }

    if(this.state.selectedTags.length === 0) {
      this.setState({
          selectedTags: [1,2,3,4]
      })
    }

    if(this.props.meetingId != undefined) {
      this.setState({ meetingId: this.props.meeting_id})
    }
  }

  updateSelectedTags(n) {
    if(this.state.selectedTags.includes(n)) {
      let newSelectedLevels = this.state.selectedTags.filter(function(e) { return e !== n })
      this.setState({
        selectedTags: newSelectedLevels
      }, () => this.searchTopics())
    } else {
      let selectedTags = this.state.selectedTags
      let newSelectedLevels = selectedTags.concat(n)
      this.setState({
        selectedTags: newSelectedLevels
      }, () => this.searchTopics())
    }
  }

  onSelectTab(n) {
    this.setState({
      selectedTab: n
    }, () => this.getTopicsApiCall())

  }

  unfavoriteTopic(id) {
    let array = this.state.savedTopicsIds
    let index = array.indexOf(id);
    let newArray = array.splice(index)
    this.setState({
      selected: newArray
    })
  }



  favoriteTopic(id) {
    let array = this.state.savedTopicsIds
    array.push(id)
    this.setState({
      selected: array
    })
  }

  topicList(array) {
    let topicsList = array.map((topic, index) => {
      return(<TopicElement
        unfavoriteTopic={this.unfavoriteTopic}
        favoriteTopic={this.favoriteTopic}
        selectedTags={this.state.savedTopicsIds}
        topic={topic}
        key={topic.id}
        index={topic.id}
        favoriteStarLottie={this.props.favoriteStarLottie}
        meetingId={this.props.meetingId}
        />)
    })
    return topicsList
  }

  showTopics() {
    let topicsList = ''
    if(this.state.selectedTab === 3) {
      if(this.state.allTopics != '') {
        return this.topicList(this.state.allTopics)
      }
      return null
    } else if (this.state.selectedTab === 2) {
      if(this.state.myTopics.length > 0) {
        return this.topicList(this.state.myTopics)
      }
      return <h3 style={{color: 'white', paddingTop: 24, textAlign: 'center'}}>You have not created any activities yet.</h3>

    } else if (this.state.selectedTab === 1) {
      if(this.state.savedTopics.length === 0) {
        return <h3 style={{color: 'white', paddingTop: 24, textAlign: 'center'}}>No saved topics. Click Search, and the Star topics to save</h3>
      }
        return this.topicList(this.state.savedTopics)
    }
  }

  newButton() {
    return(
      <div style={{margin: 'auto', maxWidth: 350, display: 'flow-root'}}>
        <button onClick={() => window.location.assign("/new_topic")} style={{backgroundColor: '#1EBEA5', float: 'right', cursor: 'pointer', borderRadius: 20, color: 'white', height: 35, width: 80, fontSize: 14}}>+ New</button>
      </div>
    )
  }

  render() {
    return(
      <div className="topics_container">
        <h3 style={{color: '#01579B', textAlign: 'center', fontWeight: 600, marginTop: 12, marginBottom: 12}}>Lex Topics and Activities</h3>
        <TopicSelector selectedTab={this.state.selectedTab} onSelectTab={this.onSelectTab}/>
        {this.state.selectedTab === 3 && <SearchBar updateSearchText={this.updateSearchText} searchText={this.state.searchText} searchTopics={this.searchTopics} searchLottie={this.props.searchLottie} />}
        {this.state.selectedTab === 3 && <TopicTags tags={this.state.tags} selectedTags={this.state.selectedTags} updateSelectedTags={this.updateSelectedTags}/>}
        {this.state.selectedTab === 2 && this.newButton()}

        <div style={{display: 'flex', margin: 'auto', justifyContent: 'center', marginTop: 24, flexWrap: 'wrap'}}>
          {this.showTopics()}
        </div>
      </div>

    )
  }

}

export default TopicsContainer;
